import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { ActionsGroup, DialogActions, DialogTitle, RaisedButton, TitleText } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { getLayerCopyrights } from "ducks/layerCopyrights/selectors";
import { Dialog, DialogContent, LayerCopyrightItem } from "./styled";
import { useGetCopyrights } from "../../../hooks/useGetCopyrights";

interface LayerCopyrightsProps {
  basemap: string;
  isOpen: boolean;
  toggleOpen: VoidFunction;
}

export const LayerCopyrights: FC<LayerCopyrightsProps> = ({ basemap, isOpen, toggleOpen }) => {
  const { t } = useTranslation();
  const copyrights = useGetCopyrights();
  const layerCopyrights = useSelector(getLayerCopyrights);

  const renderBaseCopyright = useMemo(() => {
    const copyright = copyrights.find(copy => copy.names.includes(basemap));

    if (!copyright) {
      return null;
    }

    return <LayerCopyrightItem>{copyright.CopyrightComponent}</LayerCopyrightItem>;
  }, [basemap, copyrights]);

  const renderLayerCopyrights = useMemo(
    () => (
      <>
        {layerCopyrights.map(layerCopyright => (
          <LayerCopyrightItem key={layerCopyright}>{layerCopyright}</LayerCopyrightItem>
        ))}
      </>
    ),
    [layerCopyrights],
  );

  return (
    <Dialog modal zIndex={999} isOpen={isOpen} onCloseRequest={toggleOpen}>
      <DialogTitle>
        <TitleText>{t("layerCopyrights.copyrights", { ns: "dialogs" })}</TitleText>
      </DialogTitle>
      <DialogContent>
        {renderBaseCopyright}
        {renderLayerCopyrights}
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={toggleOpen}>
            {t("actions.ok", { ns: "common" })}
          </RaisedButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
